import { Box, Button, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SubscriptionInterface } from "../../common/interfaces";
import api from "../../services/api";
import { ToastError, ToastSuccess } from "../toaster/toast.utils";

interface SetPaymentCreateModalProps {
  open: boolean;
  onClose: () => void;
  onSubscriptionSaved: () => void;
  subscription?: SubscriptionInterface | null;
}

const SetPaymentCreateModal: React.FC<SetPaymentCreateModalProps> = ({
  open,
  onClose,
  onSubscriptionSaved,
  subscription
}) => {
  const [paymentDate, setPaymentDate] = useState<string>("");
  const [paymentValue, setPaymentValue] = useState<number>(0);

  useEffect(() => {
    if (subscription) {
      setPaymentDate(new Date().toISOString().split("T")[0]); // data de hoje
      setPaymentValue(subscription.charged_amount || 0);
    } else {
      setPaymentDate("");
      setPaymentValue(0);
    }
  }, [subscription]);

  const handleSubmit = async () => {
    try {
      if (!subscription) return;

      const payload = {
        payment_date: paymentDate,
        payment_value: paymentValue
      };

      await api.patch(`/subscription/${subscription.subscription_id}`, payload);

      ToastSuccess("Pagamento registrado com sucesso!");
      onSubscriptionSaved();
      onClose();
    } catch (error: any) {
      console.error(
        "Erro ao registrar pagamento:",
        error.response?.data || error
      );
      ToastError(
        error.response?.data?.message || "Erro ao registrar pagamento."
      );
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "1px solid var(--border-strong)",
            p: 3,
            borderRadius: 2,
            boxShadow: 3,
            width: 400,
            maxHeight: "90vh",
            overflowY: "auto"
          }}
        >
          <h2>Registrar Pagamento</h2>

          <TextField
            fullWidth
            label="Data de Pagamento"
            type="date"
            value={paymentDate}
            onChange={(e) => setPaymentDate(e.target.value)}
            margin="normal"
            required
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            fullWidth
            label="Valor do Pagamento (R$)"
            type="number"
            value={paymentValue}
            onChange={(e) => setPaymentValue(Number(e.target.value))}
            margin="normal"
            required
            inputProps={{ min: 0 }}
          />

          <Box sx={{ mt: 3, textAlign: "right" }}>
            <Button onClick={onClose} sx={{ mr: 1 }}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={handleSubmit}>
              Confirmar Pagamento
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SetPaymentCreateModal;
